import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AccountService } from 'src/app/services/http/business/account/account.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { CouponService } from 'src/app/services/http/business/coupon/coupon.service';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-assign-coupon',
  templateUrl: './assign-coupon.component.html',
  styleUrls: ['./assign-coupon.component.css']
})
export class AssignCouponComponent implements OnInit {

  form: FormGroup;
  param: any;
  errorList: IError[] = [];
  errObject: any;
  errors = new Array();
  personNotFound = true;
  personInfo: any;

  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private accountService: AccountService,
    private couponService: CouponService,
    private dialogRef: MatDialogRef<AssignCouponComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      NationalCode: [null, Validators.compose([Validators.required,Validators.pattern("^[0-9]*$"),
      Validators.minLength(10),
      Validators.maxLength(12)])],
      CouponCode: [this.data.CouponCodeReadOnly]
    });
  }
  searchUser(form: any) {

    this.errors = new Array();
    this.accountService.getSimpleUserInfo(form.NationalCode).subscribe(
      res => {
        this.personNotFound = false;
        this.personInfo = res;
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }



  submit(form: any) {
    var model:any= {
      NationalCode: form.NationalCode,
      CouponId: this.data.Id
    };
    this.errors = new Array();
    this.couponService.assignCouponToStudent(model).subscribe(
      () => {
        this.dialogRef.close();
        this.snackBar.OpenSnackBar(
          this.translate.get("success.assignCoupon"),
          "ok",
          5000,
          SoundEnum.beep
        );
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
